import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetRentedOrderList } from "../../../utilities/api/pos";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

const initialState = {
  currentPage: 0,
  rowsPerPage: 0,
  totalPage: 0,
  totalRows: 0,
  RentedProductData: [] as any[],
  errorMessage: {} as ErrorMessageType,
};

export const AllRentedOrderList = createAsyncThunk(
  "RentedOrderList/AllRentedOrderList",
  (data: any) => GetRentedOrderList(data)
);

const RentedOrderListSlice = createSlice({
  name: "RentedOrderList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(
        AllRentedOrderList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            let data = action.payload.data;
            state.rowsPerPage = data.limit;
            state.currentPage = data.page;
            state.totalPage = data.totalPages;
            state.totalRows = data.totalRows;

            state.RentedProductData = data.rows.map(
              (item: any, index: number) => ({
                id: item.orderId,
                srNo: index + 1,
                name: item.name,
                customerName:
                  item.order.user.firstName + " " + item.order.user.lastName,
                phone: item.order.user.phone,
                createdAt: item.createdAt,
                quantity: item.quantity,
                startTime: item.startTime,
                duration: item.duration,
                rentingPrice: Math.round(
                  item.rentingPrice +
                  (Number(item.rentingPrice) *
                    Number(
                      item.rentingOrderItemTaxes?.length > 1
                        ? item.rentingOrderItemTaxes?.reduce(
                          (acc: any, cur: any) =>
                            Number(acc.percentage) + Number(cur.percentage)
                        )
                        : item.rentingOrderItemTaxes[0].percentage
                    )) /
                  100
                ),
                totalAmount: Math.round(
                  item.totalAmount +
                  (Number(item.totalAmount) *
                    Number(
                      item.rentingOrderItemTaxes?.length > 1
                        ? item.rentingOrderItemTaxes?.reduce(
                          (acc: any, cur: any) =>
                            Number(acc.percentage) + Number(cur.percentage)
                        )
                        : item.rentingOrderItemTaxes[0].percentage
                    )) /
                  100
                ),
                status: item.status,
                hash: item.hash,
              })
            );
          }
        }
      )
      .addCase(AllRentedOrderList.rejected, (state, action) => {
            state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default RentedOrderListSlice.reducer;
